/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum RespiratoryMonitoringAliases {
  BUTTON_ADD_RESPIRATORY_MONITORING = 'button-add-respiratory-monitoring',
  DATE_PICKER_END_DATE = 'date-picker-end-date',
  DATE_PICKER_START_DATE = 'date-picker-start-date',
  DECK_VITAL_SIGN = 'deck-vital-sign',
  FETCH_VITAL_SIGN = 'fetch-vital-sign',
  FILTER_FIELD_DATE_END = 'filter-field-date-end',
  FILTER_FIELD_DATE_START = 'filter-field-date-start',
  FILTERED_LIST_0 = 'filtered-list-0',
  GLOBAL_ACTIONS_0 = 'global-actions-0',
  PANEL_1 = 'panel-1',
  PANEL_GLOBAL_ACTIONS = 'panel-global-actions',
  RESPIRATORY_MONITORING_CARD = 'respiratory-monitoring-card',
  RESPIRATORY_MONITORING_CONTEXTUAL_BAR = 'respiratory-monitoring-contextual-bar',
  RESPIRATORY_MONITORING_FILTER = 'respiratory-monitoring-filter',
  RESPIRATORY_MONITORING_LAYOUT = 'respiratory-monitoring-layout',
  RESPIRATORY_MONITORING_LEGENDS = 'respiratory-monitoring-legends',
}
export { RespiratoryMonitoringAliases };
